import { ACADEMY_ROUTES } from '@/shared/academy.const'

import type { LearningPath, PopularTopic } from './academy.interface'

export const LEARNING_PATHS: LearningPath[] = [
  {
    id: 'frontend',
    title: 'Quick start',
    description:
      'Learn how to consume Grafts directly in your frontend. Connect services to your React, Vue, or Angular app in just a few minutes.',
    imageSrc: '/quick-start-image.png',
    imageAlt: 'Quick start illustration',
    href: ACADEMY_ROUTES.quickStart,
  },
]

export const POPULAR_TOPICS: PopularTopic[] = [
  {
    id: 'get-started',
    title: 'Get started',
    description: 'Learn the essentials to begin quickly',
    iconType: 'rocket',
    articles: [
      { title: 'Beginner GraftCode tutorials', href: ACADEMY_ROUTES.documentation },
      { title: 'Try GraftCode in your browser', href: ACADEMY_ROUTES.documentation },
      { title: 'Quickstart in 5 minutes', href: ACADEMY_ROUTES.quickStart },
      { title: 'Inside a GraftCode program', href: ACADEMY_ROUTES.documentation },
      { title: 'Beginner video series', href: ACADEMY_ROUTES.documentation },
      { title: 'Foundational certification', href: ACADEMY_ROUTES.documentation },
    ],
  },
  {
    id: 'core-concepts',
    title: 'Core concepts',
    description: 'Understand key principles of Graftcode',
    iconType: 'atom',
    articles: [
      { title: 'What is a Graft?', href: ACADEMY_ROUTES.documentation },
      { title: 'Local vs. remote execution', href: ACADEMY_ROUTES.documentation },
      { title: 'Calling foreign modules', href: ACADEMY_ROUTES.documentation },
      { title: 'Package manager integration', href: ACADEMY_ROUTES.documentation },
      { title: 'GraftVision overview', href: ACADEMY_ROUTES.documentation },
      { title: 'Exposing your module', href: ACADEMY_ROUTES.documentation },
    ],
  },
  {
    id: 'building',
    title: 'Building with Graftcode',
    description: 'Apply Graftcode to real projects',
    iconType: 'building',
    articles: [
      { title: 'Modular monolith with GraftCode', href: ACADEMY_ROUTES.documentation },
      { title: 'Multi-runtime apps', href: ACADEMY_ROUTES.documentation },
      { title: 'Authorization & authentication', href: ACADEMY_ROUTES.documentation },
      { title: 'Auto-updated clients', href: ACADEMY_ROUTES.documentation },
      { title: 'Performance benefits', href: ACADEMY_ROUTES.documentation },
      { title: 'Package manager integration', href: ACADEMY_ROUTES.documentation },
    ],
  },
  {
    id: 'advanced',
    title: 'Advanced topics',
    description: 'Tackle complex and large-scale scenarios',
    iconType: 'circuit',
    articles: [
      { title: 'Integrating legacy systems', href: ACADEMY_ROUTES.documentation },
      { title: 'Automatic interface updates', href: ACADEMY_ROUTES.documentation },
      { title: 'Using GraftCode with AI', href: ACADEMY_ROUTES.documentation },
      { title: 'Private cloud / on-prem hosting', href: ACADEMY_ROUTES.documentation },
      { title: 'Large scale microservices integration', href: ACADEMY_ROUTES.documentation },
      { title: 'Calling foreign modules', href: ACADEMY_ROUTES.documentation },
    ],
  },
]

export const OVERLAY_CARD_TITLES: Record<string, string> = {
  frontend: 'Frontend developer',
  backend: 'Backend developer',
  fullstack: 'Fullstack developers path',
}

export const OVERLAY_CARD_DESCRIPTIONS: Record<string, string> = {
  frontend:
    'Consume Grafts directly in your frontend app (React, Vue, Angular). Connect services without backend overhead.',
  backend: 'Deploy and expose backend services as Grafts. Build APIs and connect runtimes without boilerplate code.',
  fullstack:
    'Discover the full flow — deploy a backend service, expose logic, and consume it in a frontend app. End-to-end integration made simple.',
}
